import { useEffect, useState } from 'react'


export const useStopWatch = (isOn :boolean, initialTime : number) => {
    const [timerValue, setTimerValue] = useState<number>(initialTime);

    useEffect(() => {
          setTimerValue(initialTime);
      }, [initialTime]);

    useEffect(() => {
        // Create an interval that updates the timer value every second
        const countInterval = setInterval(() => {
            // Increment the timer value by 1 second and update the state
            if(!isOn) return;

            setTimerValue((prevValue) => prevValue + 1);
        }, 1000);
    
        // Clean up the interval when the component unmounts
        return () => clearInterval(countInterval);
      }, [isOn]);

    

    const time = FormatTime(timerValue);
    return {time: time, timerValue};
}

export const FormatTime = (time : number) : string => {
    // I want to format the time as mm:ss
    // 1. Divide the time by 60 to get the minutes
    const minutes = Math.floor(time / 60);
    // 2. Get the seconds by using modulo
    const seconds = time % 60;
    // 3. Format the minutes and seconds to look nice
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');
    // 4. Return the formatted time
    return `${formattedMinutes}:${formattedSeconds}`;
}